exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.divBackground[data-v-6f0abab6] {\n  height: 745px;\n}\n.posDiv[data-v-6f0abab6] {\n  position:relative;\n  cursor: pointer;\n  width: 150px;\n  float: left;\n  z-index:100\n}\n.posDiv i[data-v-6f0abab6] {\n  position: relative;\n  left: -35px;\n  top: -28px;\n  color: red;\n}\n", ""]);

// exports
